import { StyleSheet, View } from "react-native";

import { SearchInput } from "@/components/SearchInput";
import { Overline } from "@/design/Text";
import { space } from "@/design/tokens";

/**
 * The one "ALL DANCES + search" block used above every dance list (performance
 * page program, watch-page queue), so heading and placeholder stay identical
 * everywhere. The surrounding ContentSection owns the gap down to the first
 * row, just as it does for every other primary page section.
 */
export function DanceListHeader({
  title,
  value,
  onChangeText,
  onSearchBlur,
  onSearchFocus
}: {
  title: string;
  value: string;
  onChangeText: (text: string) => void;
  onSearchBlur?: () => void;
  onSearchFocus?: () => void;
}) {
  return (
    <View>
      <Overline style={styles.heading}>{title}</Overline>
      <SearchInput
        value={value}
        onChangeText={onChangeText}
        onBlur={onSearchBlur}
        onFocus={onSearchFocus}
        placeholder="Search dancers, dances, styles…"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  heading: {
    marginBottom: space.sm
  }
});
